import { t } from 'i18next';

enum ReportParticipantType {
    Reviewer = 1,
    Supervisor = 2,
    CreatedBy = 3,
    ValidatedBy = 5,
}

export const ALL_REPORT_PARTICIPANT_TYPES = [
    ReportParticipantType.Reviewer,
    ReportParticipantType.Supervisor,
    ReportParticipantType.CreatedBy,
    ReportParticipantType.ValidatedBy,
];

export const getReportParticipantTypeLabel = (type: ReportParticipantType): string => {
    switch (type) {
        case ReportParticipantType.Reviewer:
            return t('Reviewer');
        case ReportParticipantType.Supervisor:
            return t('Supervisor');
        case ReportParticipantType.CreatedBy:
            return t('CreatedBy');
        case ReportParticipantType.ValidatedBy:
            return t('ValidatedBy');
    }
};

export default ReportParticipantType;
